import { render, staticRenderFns } from "./plusButton.vue?vue&type=template&id=37a18fac&scoped=true&"
import script from "./plusButton.vue?vue&type=script&lang=js&"
export * from "./plusButton.vue?vue&type=script&lang=js&"
import style0 from "./plusButton.vue?vue&type=style&index=0&id=37a18fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a18fac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a18fac')) {
      api.createRecord('37a18fac', component.options)
    } else {
      api.reload('37a18fac', component.options)
    }
    module.hot.accept("./plusButton.vue?vue&type=template&id=37a18fac&scoped=true&", function () {
      api.rerender('37a18fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/TagsView/header/plusButton.vue"
export default component.exports